if (!customElements.get("cart-terms-checkbox")) {
  customElements.define(
    "cart-terms-checkbox",
    class CartTermsCheckbox extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector("#accept-terms");
        this.checkoutBtn = document.getElementById("CartDrawer-Checkout");
        this.cartDrawer = this.closest("cart-drawer");
        this._handleChange = this._handleChange.bind(this);
      }

      connectedCallback() {
        if (!this.checkbox || !this.checkoutBtn) return;
        this.checkbox.addEventListener("change", this._handleChange);
      }

      disconnectedCallback() {
        if (this.checkbox) {
          this.checkbox.removeEventListener("change", this._handleChange);
        }
      }
      _setLoading(state) {
        if (!this.cartDrawer) return;
        if (state) {
          this.cartDrawer.classList.add("is-loading");
          this.cartDrawer
            .querySelectorAll("cart-drawer-items button")
            .forEach((btn) => (btn.disabled = true));
        } else {
          this.cartDrawer.classList.remove("is-loading");
          this.cartDrawer
            .querySelectorAll("cart-drawer-items button")
            .forEach((btn) => (btn.disabled = false));
        }
      }

      async _handleChange(e) {
        const isChecked = e.target.checked;
        this.checkoutBtn.disabled = true;
        this._setLoading(true);

        try {
          const res = await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              attributes: { accepted_terms: isChecked ? "true" : "false" },
            }),
          });
          if (!res.ok) {
            console.error(`Cart update failed: ${res.status} ${res.statusText}`);
            return;
          } else {
            const json = await res.json();
            if (json?.attributes?.accepted_terms === "true") {
              this.checkoutBtn.disabled = false;
            }
          }
        } catch (err) {
          console.error("Failed to update cart attribute", err);
        } finally {
          this._setLoading(false);
        }
      }
    }
  );
}
